export default "__VITE_ASSET__5c6893ed__$_?component__"